import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'

export const tenant = {
  path: '/tenantManagement/',
  name: 'tenantManagement',
  component: LayoutWithSideMenu,
  meta: {
    title: '租户管理'
  },
  children: [
    {
      path: 'tenant-mode',
      name: 'tenant-mode',
      component: () => import('@/views/tenant/tenant-mode'),
      meta: {
        title: '服务模式管理'
      }
    },
    {
      path: 'tenant-message',
      name: 'tenant-message',
      component: () => import('@/views/tenant/tenant-message'),
      meta: {
        title: '租户信息'
      }
    },
    {
      path: 'tenant-model',
      name: 'tenant-model',
      component: () => import('@/views/tenant/tenant-model'),
      meta: {
        title: '租户功能管理'
      }
    },
    {
      path: 'tenant-notice',
      name: 'tenant-notice',
      component: () => import('@/views/tenant/tenant-notice'),
      meta: {
        title: '租户通知'
      }
    }
  ]
}
